import { CreateOutletPayload, CreateOutletResponse, OutletItemV2 } from "services/api/types";
import Outlet from "../types/Outlet";
import { useAppDispatch } from "app/hooks/hooks";
import { createOutlet } from "redux/userList/userSlice";
import { DATE_FORMAT } from "../config";
import ActionType from "../types/ActionType";
import axios from "axios";

const useCreateOrUpdateOutlet = () => {
	const dispatch = useAppDispatch();

	const getUntaggedOutlets = (tags: string[] = [], originalTags: string[] = []): string[] => {
		return originalTags.filter((originalTag) => !tags.includes(originalTag));
	};

	const getFormattedPayload = (outlets: Outlet[], actionType: ActionType = "create"): CreateOutletPayload => ({
		flags: actionType === "create" ? "create" : "update",
		data: outlets.map((outlet) => {
			return {
				// required fields
				cust_no: outlet.tenantCode,
				cust_name: outlet.tenantName,
				tenant_no: outlet.outletCode,
				concession: outlet.concession,
				outlet: outlet.outletName,

				// Only required if participating in Changi EV is checked
				vendor_code: outlet.vendorCode,

				// optional fields
				rental_serial_no: outlet.rentalSerialNo ?? "",
				location: outlet.location ?? "",
				terminal: outlet.terminal ?? "",
				unit_no: outlet.unitNo ?? "",
				trade: outlet.trade ?? "",
				air_land: outlet.airLand ?? "",
				business_cat: outlet.businessCategory ?? "",
				prod_category: outlet.productCategory ?? "",
				floor_name: outlet.floorName ?? "",
				category_type_1: outlet.categoryType1 ?? "",
				category_type_2: outlet.categoryType2 ?? "",
				category_type_3: outlet.categoryType3 ?? "",
				category_type_4: outlet.categoryType4 ?? "",
				category_type_5: outlet.categoryType5 ?? "",
				active: outlet.outletStatus ? "true" : "false",
				participating: outlet.participatingInChangiEv ? "true" : "false",
				eff_date: outlet.effectiveDate ? outlet.effectiveDate.format(DATE_FORMAT) : "",
				expiry_date: outlet.expiryDate ? outlet.expiryDate.format(DATE_FORMAT) : "",
				tag: outlet.tags,
				untag: getUntaggedOutlets(outlet.tags, outlet.originalTags)
			} as OutletItemV2;
		})
	});

	const createOrUpdateOutlet = async (outlets: Outlet[], actionType: ActionType = "create") => {
		const payload = getFormattedPayload(outlets, actionType);

		try {
			const resultAction = await dispatch(createOutlet(payload));
			const response = resultAction.payload;

			if (!response) {
				throw new Error("Failed to create or update outlet");
			}

			if (axios.isAxiosError(response)) {
				const { errors } = response?.response?.data as CreateOutletResponse;
				throw new Error(errors[0].code);
			}

			return response;
		} catch (error) {
			throw new Error(error instanceof Error ? error.message : String(error));
		}
	};

	return { getFormattedPayload, createOrUpdateOutlet };
};

export default useCreateOrUpdateOutlet;
